import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CreateClientSecret, DeleteClientSecret, ListClients, useClient } from "./ClientStore";
import * as IdentityPermissionStore from "../identityPermissions/IdentityPermissionStore";

import { useNavigate, useParams } from "react-router-dom";
import { FormGroup, Input, Label } from "reactstrap";
import { getOrganizations } from "../organizations/OrganizationStore";

import { find, get } from "lodash";

export const ManageExternalClient = ({ user, policies }) => {
    const [clients, setClients] = React.useState([]);
    const [organizations, setOrganizations] = React.useState([]);

    React.useEffect(() => {
        ListClients().then((res) => {
            setClients(res.data);
        });
        getOrganizations((organizations) => {
            setOrganizations(organizations);
        });
    }, []);

    const navigate = useNavigate();

    return (
        <>
            <>
                Manage external client access to your organization
                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: "70%" }}>Client</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {clients.map((client) => (
                            <tr key={client.id}>
                                <td>
                                    {get(find(organizations, { id: client.organization }), "name", "No Organization")} - {client.name}
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        className="btn btn-outline-warning me-2"
                                        onClick={() => {
                                            navigate(`/organizations/clients/${client.id}/permissions`);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={["fad", "users-cog"]}></FontAwesomeIcon>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        </>
    );
};
